import {
  DesktopCategoryNavbar,
  MobileCategoryNavbar
} from "@outschool/ui-components-website";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { useTutoringNavMenus } from "./hooks/useTutoringNavMenus";

export default function NavBar() {
  const navbarCategories = useTutoringNavMenus();
  const isMobile = useIsMobile();

  return (
    <nav>
      {isMobile ? (
        <MobileCategoryNavbar categories={navbarCategories} />
      ) : (
        <DesktopCategoryNavbar
          categories={navbarCategories}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "5rem"
          }}
        />
      )}
    </nav>
  );
}
